<div class="flex flex-col gap-4">

  <app-hospital [assigned]="true"></app-hospital>

  <!-- <in-home-care-change [assigned]="true"></in-home-care-change> -->

</div>
